import React from 'react';
import { WithChildren } from 'types/withChildren';

import styles from './style.module.scss';

export const RadiusShadowContainer: React.FC<WithChildren> = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};
